import type { CSSProperties, ReactNode } from 'react';

interface GlitchTitleProps {
  text: string;
  as?: 'h1' | 'h2' | 'h3';
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}

export default function GlitchTitle({
  text,
  as: Tag = 'h1',
  className,
  style,
}: GlitchTitleProps) {
  const combined = className ? `glitch ${className}` : 'glitch';
  return (
    <Tag className={combined} data-text={text} style={style}>
      {text}
    </Tag>
  );
}
